export interface MeasuredArtifactRow<Section extends string> { section: Section; height: number }
export interface ArtifactPageGroup<Section extends string> { section: Section; rowIndexes: number[]; continued: boolean }
export interface ArtifactPage<Section extends string> { groups: ArtifactPageGroup<Section>[] }

/** Pack measured physical rows. Logical seats may have explicitly labeled work continuations. */
export function paginateArtifactRows<Section extends string>(
  rows: readonly MeasuredArtifactRow<Section>[],
  headings: Readonly<Record<Section, number>>,
  availableHeight: number,
): ArtifactPage<Section>[] | null {
  if (!Number.isFinite(availableHeight) || availableHeight <= 0 || rows.length === 0) return null;
  const pages: ArtifactPage<Section>[] = [];
  let page: ArtifactPage<Section> = { groups: [] };
  let used = 0;
  for (let index = 0; index < rows.length; index += 1) {
    const row = rows[index]!;
    const heading = headings[row.section];
    if (!Number.isFinite(row.height) || row.height <= 0 || !Number.isFinite(heading) || heading <= 0
      || row.height + heading > availableHeight) return null;
    let group = page.groups.at(-1);
    const needed = row.height + (group?.section === row.section ? 0 : heading);
    if (used + needed > availableHeight) {
      pages.push(page);
      page = { groups: [] };
      used = 0;
      group = undefined;
    }
    if (group?.section !== row.section) {
      group = { section: row.section, rowIndexes: [], continued: index > 0 && rows[index - 1]?.section === row.section };
      page.groups.push(group);
      used += heading;
    }
    group.rowIndexes.push(index);
    used += row.height;
  }
  if (page.groups.length > 0) pages.push(page);
  return pages;
}
